export const GET_USER_INFO: string = 'GET_USER_INFO';
export const FETCH_USERINFO_START: string = 'FETCH_USERINFO_START';
export const FETCH_USERINFO_SUCCESS: string = 'FETCH_USERINFO_SUCCESS';
export const FETCH_USERINFO_FAIL: string = 'FETCH_USERINFO_FAIL';
export const CREATE_APP_SUCCESS: string = 'CREATE_APP_SUCCESS';
export const DELETE_APP_SUCCESS: string = 'DELETE_APP_SUCCESS';
export const RENAME_APP_SUCCESS: string = 'RENAME_APP_SUCCESS';
export const PRICING_BANNER_TOOGLE: string = 'PRICING_BANNER_TOOGLE';
export const SET_SELECTED_APP: string = 'SET_SELECTED_APP';